// src/components/Fields/MultiSelectFieldPreview.jsx
import React from 'react';
import { Typography, Box } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox'; // Multi-Select Checkbox Icon
import DraggablePreviewWrapper from './DraggablePreviewWrapper';  // Ensure the path is correct
import { useFormLayout } from '../../contexts/FormLayoutContext'; // Adjust path as necessary

const MultiSelectFieldPreview = ({ id, index }) => {
    const { showDropZones, setShowDropZones } = useFormLayout();  // Use context to manage showDropZones

    return (
        <DraggablePreviewWrapper
            id={id}
            type="multi-select"
            index={index}
            isNew={true}
            showDropZones={showDropZones} // Pass down showDropZones state
            setShowDropZones={setShowDropZones} // Pass down setShowDropZones function
        >
            <Box display="flex" alignItems="center">
                <CheckBoxIcon sx={{ fontSize: '0.95rem', marginRight: '8px', color: '#455A64' }} />
                <Typography variant="body2" sx={{ flexGrow: 1, fontSize: '0.85rem', color: '#455A64' }}>
                    Multi-Select
                </Typography>
            </Box>
        </DraggablePreviewWrapper>
    );
};

export default MultiSelectFieldPreview;
